import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";

function CheckoutSuccess() {
  const navigate = useNavigate();

  return (
    <div className="checkout-container">
      <Navbar hideAuth />
      <div className="checkout-message success">
        <h1>🎉 ¡Pago exitoso!</h1>
        <p>Gracias por tu compra. Tu suscripción ha sido activada correctamente.</p>
        <button onClick={() => navigate("/")}>Volver al inicio</button>
      </div>
    </div>
  );
}

export default CheckoutSuccess;
